import React from 'react';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { largeDesktop, mediumDesktop, tablet } from 'helpers/utils/screensizes';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import dynamic from 'next/dynamic';
import { trackEvent } from 'helpers/customEvents';
const Markdown = dynamic(() => import('../../organisms/markdown'));

export type ImageHTMLContentProps = {
  data?: any;
};

const ImageHTMLContent = ({ data }: React.PropsWithChildren<ImageHTMLContentProps>) => {
  const [isDesktopSize] = useMediaQuery(largeDesktop);
  const [isTabletSize] = useMediaQuery(tablet);

    return (
    <div className={`flex items-center ${data?.content_alignment === 'Center' || 'right' ? 'flex-col text-center' : 'flex-row'}`}>
      <div className="flex-1  flex-grow px-24 ">
        <Typography as="h1" className="pb-32 text-32 xl:text-28 2xl:text-32 font-medium leading-10 text-[#090909] lg:leading-9">
          {data?.title}
        </Typography>
        <Markdown
          markdown={data?.description}
          className="pb-48 font-normal leading-8 text-[#333] text-1rem 2xl:text-[1.25rem] 2xl:px-180 2xl:pb-60"
        />

        {data?.button &&
          data?.button.map((ctaButton: { href: string | Reference | undefined; title: string | undefined }) => (
            <Link link={ctaButton?.href} key={ctaButton?.title}>
              <Button 
                className="mt-22 rounded-none bg-[#2B2C39] shadow-sm hover:!bg-[#394A54] md:mt-36 md:px-32 md:py-18 lg:mt-32"
                onClick={() => trackEvent('banner_click', { cta_title: ctaButton?.title, cta_url: ctaButton?.href })}
              >
                <Typography as="span" className="text-12 text-white xl:text-14 2xl:text-16">
                  {ctaButton?.title}
                </Typography>
              </Button>
            </Link>
          ))}
      </div>
      {data?.video_link?.href && (
        <iframe
          src={data?.video_link?.href}
          width="100%"
          height={isTabletSize ? '720' : '320'}
          allowFullScreen
        ></iframe>
      )}
      {/* <div className="relative w-full flex-1 flex-grow md:h-[600px] xl:h-[746px]">
        <Image priority src={data?.image?.url} alt={data?.image?.description} fill style={{ objectFit: 'cover' }} />
      </div> */}
    </div>
  );
};

export default ImageHTMLContent;
